import { useRouter } from '@/navigation';
import { useCwcJackpotRulesPopupViewedStatus } from '@/hooks/query/cwc-jackpot/use-cwc-jackpot-rules-popup-viewed-status';
import { scoreChallengeModalService } from '@/services/cwc-jackpot/cwc-jackpot-modal.service';
import { useLocale } from 'next-intl';

export const useCwcEntry = () => {
	const router = useRouter();
	const locale = useLocale();
	const { data: viewedStatus, isLoading  } = useCwcJackpotRulesPopupViewedStatus();
	return () => {
		// 直接導轉到專區，專區內在判斷是否是第一次進
		router.push('/promotion/score-challenge/pool-games', { locale });
	};
};